<template>
    <div
        class="conversation-item-container"
        :class="{ 'choose': conversation.conversationID === currentConversation.conversationID }"
        @click="selectConversation"
    >
        <div class="close-btn">
            <span
                class="el-icon-delete"
                :title="$t('删除会话')"
                @click="deleteConversation"
            />
        </div>
        <div class="warp">
            <v-avatar
                :src="avatar"
                :type="conversation.type"
            />
            <div class="content">
                <div class="row-1">
                    <div class="name">
                        <div class="text-ellipsis">
                            <span
                                v-if="conversation.type === $TIM_TYPES.CONV_C2C"
                                :title="conversation.userProfile.nick || conversation.userProfile.userID"
                            >{{ conversation.remark || conversation.userProfile.nick || conversation.userProfile.userID }}
                            </span>
                        </div>
                    </div>
                    <div class="unread-count">
                        <span
                            v-if="showUnreadCount"
                            class="badge"
                        >
                            {{ conversation.unreadCount > 99 ? '99+' : conversation.unreadCount }}
                        </span>
                    </div>
                </div>
                <div class="row-2">
                    <div class="summary">
                        <div
                            v-if="conversation.lastMessage"
                            class="text-ellipsis"
                        >
                            <span
                                class="text"
                                :title="conversation.lastMessage.messageForShow"
                            >
                                {{ messageForShow }}
                            </span>
                        </div>
                    </div>
                    <div class="date">
                        {{ date }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Avatar from './Avatar.vue'
import { mapGetters, mapState } from 'vuex'
import { isToday, getDate, getTime } from '@/utils/funcTim.js'

export default {
    name: 'ConversationItem',
    components: {
        'v-avatar': Avatar
    },
    props: [ 'conversation' ],
    data() {
        return {
            popoverVisible: false,
            showMessageAtMe_text: ''
        }
    },
    computed: {
        ...mapState({
            currentConversation: state => state.timStore.currentConversation,
            currentUserProfile: state => state.timStore.currentUserProfile
        }),
        ...mapGetters([ 'toAccount',
        // 'currentConversation', 'currentUserProfile' 
        ]),
        showUnreadCount() {
            // if (this.$store.getters.hidden) {
            //     return this.conversation.unreadCount > 0
            // }
            // 是否显示未读计数。当前会话和未读计数为0的会话，不显示。
            return this.currentConversation.conversationID !== this.conversation.conversationID && this.conversation.unreadCount > 0
        },
        date() {
            if (!this.conversation.lastMessage || !this.conversation.lastMessage.lastTime) {
                return ''
            }
            const date = new Date(this.conversation.lastMessage.lastTime * 1000)
            if (isToday(date)) {
                return getTime(date)
            }
            return getDate(date)
        },
        avatar() {
            switch (this.conversation.type) {
                case 'C2C':
                    return this.conversation.userProfile.avatar
                default:
                    return ''
            }
        },
        conversationName() {
            if (this.conversation.type === this.$TIM_TYPES.CONV_C2C) {
                return this.conversation.userProfile.nick || this.conversation.userProfile.userID
            }
            return ''
        },
        messageForShow() {
            if (this.conversation.lastMessage.isRevoked) {
                if (this.conversation.lastMessage.fromAccount === this.currentUserProfile.userID) {
                    return this.$t('你撤回了一条消息')
                }
                if (this.conversation.type === this.$TIM_TYPES.CONV_C2C) {
                    return this.$t('对方撤回了一条消息')
                }
                return `${this.conversation.lastMessage.fromAccount}${this.$t('撤回了一条消息')}`
            }
            return this.conversation.lastMessage.messageForShow
        }
    },
    mounted() {

    },
    methods: {
        async selectConversation() {
            console.log(this.currentConversation)
            if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
                await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
            }
            if (this.conversation.conversationID !== this.currentConversation.conversationID) {
                await this.$store.dispatch('checkoutConversation', this.conversation.conversationID)
            }
        },
        deleteConversation(event) {
            // 停止冒泡，避免和点击会话的事件冲突
            event.stopPropagation()
            this.$TIM
                .deleteConversation(this.conversation.conversationID)
                .then(() => {
                    this.$message.success(`${this.$t('会话')}【${this.conversationName}】${this.$t('删除成功')}!`)
                    this.popoverVisible = false
                    this.$store.commit('resetCurrentConversation')
                })
                .catch((error) => {
                    this.$message.error(`${this.$t('会话')}【${this.conversationName}】${this.$t('删除失败')}!, error=${error.message}`)
                    this.popoverVisible = false
                })
        },
        showContextMenu() {
            this.popoverVisible = true
        }
    }
}
</script>

<style lang="scss" scoped>
.conversation-item-container {
    padding: 15px 20px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: .2s;
    border-bottom: 1px solid #eeeeee;
    &:hover {
        background-color: #eeeeee;
        .close-btn {
            right: 3px;
        }
    }
    .close-btn {
        position: absolute;
        right: -20px;
        top: 3px;
        color: #76828c;
        transition: all .2s ease;
        &:hover {
            color: #f35f5f;
        }
    }
    .warp {
        display: flex;
    }
    .avatar {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        border-radius: 5px;
        flex-shrink: 0;
    }
    .content {
        flex: 1;
        height: 40px;
        overflow: hidden;
        .row-1 {
            display: flex;
            line-height: 21px;
            .name {
                color: #000000;
                flex: 1;
                min-width: 0px;
            }
            .unread-count {
                padding-left: 10px;
                flex-shrink: 0;
                color: #76828c;
                font-size: 12px;
                .badge {
                        vertical-align: bottom;
                        background-color: #f35f5f;
                        border-radius: 10px;
                        color: #FFF;
                        display: inline-block;
                        font-size: 12px;
                        height: 18px;
                        max-width: 40px;
                        line-height: 18px;
                        padding: 0 6px;
                        text-align: center;
                        white-space: nowrap;
                }
            }
        }
        .row-2 {
            display: flex;
            font-size: 12px;
            padding-top: 3px;
            .summary {
                flex: 1;
                overflow: hidden;
                min-width: 0px;
                color: #a5b5c1;
                .remind {
                    color: #f35f5f;
                }
            }
            .date {
                padding-left: 10px;
                flex-shrink: 0;
                text-align: right;
                color: #76828c;
            }
        }
    }
}
.choose {
    background-color: #eeeeee;
}
.context-menu-button {
    padding: 10px;
    border: 2px solid #2d8cf0;
    border-radius: 8px;
}
</style>
